import isKeyable from './_isKeyable.js';

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

export default getMapData;



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/_getMapData.js
// module id = 129
// module chunks = 0